module.exports = __webpack_public_path__ + "media/images/v2/download-c490e97b5fb1d54e7061e8aa7b542fd1.png";